import { render, staticRenderFns } from "./ConversationSummarizer.vue?vue&type=template&id=0f7fe103&scoped=true"
import script from "./ConversationSummarizer.vue?vue&type=script&lang=js"
export * from "./ConversationSummarizer.vue?vue&type=script&lang=js"
import style0 from "./ConversationSummarizer.vue?vue&type=style&index=0&id=0f7fe103&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7fe103",
  null
  
)

export default component.exports